/* eslint-disable jsx-a11y/label-has-associated-control */
import ErrorText from 'Modules/ErrorText/ErrorText';
import { useField } from 'formik';
import PropTypes, { bool, string } from 'prop-types';
import React from 'react';
import { Form } from 'semantic-ui-react';

import styles from './FieldLayout.less';

const FieldLayout = props => {
  const { name, children, label, errorInline, prefixError, isPrefixError } = props;
  const [, meta] = useField(name);

  const errorText = meta?.error || prefixError || '';
  const touch = meta?.touched;
  const isShowError = (touch && errorText) || isPrefixError;
  return (
    <Form.Field className={styles.field} error={isShowError}>
      {label && (
        <div className="flex justify-between align-items-center mb-1">
          {label && <label>{label}</label>}
          {isShowError && errorInline && <ErrorText text={errorText} />}
        </div>
      )}
      {children}
      {meta?.touched && !!meta?.error && !errorInline && (
        <div className={styles.error}>{meta.error}</div>
      )}
    </Form.Field>
  );
};

FieldLayout.defaultProps = {
  label: '',
  prefixError: '',
  errorInline: false,
  isPrefixError: false,
};

FieldLayout.propTypes = {
  children: PropTypes.node.isRequired,
  name: string.isRequired,
  label: string,
  prefixError: string,
  errorInline: bool,
  isPrefixError: bool,
};

export default FieldLayout;
